export default __webpack_public_path__ + "static/media/redis-negative.dbe033ee.svg";